import { Button, type ButtonProps } from "@beweegbaas/ui/components/ui/button";
import { Tooltip, TooltipContent, TooltipTrigger } from "@beweegbaas/ui/components/ui/tooltip";
import { cn } from "@beweegbaas/ui/lib/utils";

export type IconButtonProps = Omit<ButtonProps, "aria-label"> & {
  /** Names the button for a screen reader and shows as its tooltip. */
  label: string;
};

/**
 * A `Button` with only an icon in it, labelled by `label`, which also shows as a tooltip. On the
 * ghost and flat variants the icon stays muted until the button is pointed at. It takes every prop
 * of `Button`, so it can be the `render` of another trigger.
 */
function IconButton({
  label,
  variant = "ghost",
  size = "icon",
  className,
  children,
  ...props
}: IconButtonProps) {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            variant={variant}
            size={size}
            aria-label={label}
            className={cn(
              (variant === "ghost" || variant === "flat") &&
                "text-muted-foreground hover:text-foreground",
              className,
            )}
            {...props}
          />
        }
      >
        {children}
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}

export { IconButton };
